// ============================================================
// CONTENU DU SITE — tout est modifiable ici, en un seul endroit.
// Textes, coordonnées, liens et photos : changez une valeur,
// le site se met à jour partout automatiquement.
// ============================================================

export const CONTENT = {
  // --- Identité ---
  name: "Sabine Sissan",
  title: "Ostéopathe D.O.",
  baseline: "Cabinet d'ostéopathie — Corps en Mouvement",

  // --- Prise de rendez-vous ---
  bookingUrl: "https://www.doctolib.fr/osteopathe/cabries/sabine-sissan",

  // --- Coordonnées ---
  phone: "06 59 83 23 90",
  email: "sabinesissan.osteopathe@gmail.com",
  address: "1321 avenue Jean Moulin, 13480 Cabriès",
  hours: [
    { day: "Mardi", time: "12h – 20h" },
    { day: "Jeudi", time: "8h – 18h" },
    { day: "Vendredi", time: "8h – 16h" },
    { day: "Samedi", time: "9h – 12h" },
  ],
  instagramUrl: "https://www.instagram.com/sabine_sissan_osteopathe",
  instagramHandle: "@sabine_sissan_osteopathe",
  adeli: "10104529978",
  memoireUrl: "https://drive.google.com/file/d/1evx89BYgWKxDU7vw0sv05uZ7uto66dVK/view",

  // --- Photos ---
  // Remplacez simplement les URL par vos propres photos
  // (photo de vous, de votre cabinet, votre personnage animé…)
  images: {
    hero: "/hero-seance.jpg",
    heroAlt: "Sabine Sissan pratiquant une manipulation douce du dos au cabinet",
    approach: "/approche-anamnese.jpg",
    approachAlt: "Sabine Sissan en temps d'écoute et d'anamnèse avec un patient au cabinet",
    portrait: "/portrait-sabine.jpg",
    portraitAlt: "Sabine Sissan, ostéopathe D.O., dans son cabinet à Cabriès",
    cabinet: "/cabinet-2.jpg",
    cabinetAlt: "Sabine Sissan en séance d'ostéopathie dans son cabinet à Cabriès",
    cabinetSecond: "/cabinet-1.jpg",
    cabinetSecondAlt: "Consultation douce d'un nourrisson au cabinet",
    ebook: "/ebook-corps-en-mouvement.jpg",
    ebookAlt: "Couverture de l'ebook Corps en Mouvement — Le Guide Complet, par Sabine Sissan",
    ebookSecond: "/ebook-10-exercices.jpg",
    ebookSecondAlt: "Couverture de l'ebook Les 10 Exercices Essentiels, par Sabine Sissan",
    mascotte: "/mascotte.jpg",
    mascotteAlt: "Mascotte illustrée de Sabine Sissan, personnage Instagram du cabinet",
  },

  // --- Lien de votre ebook ---
  ebookUrl: "#",
};
